import DFPProvider from './DFPProvider';
export default DFPProvider;